<style scoped>
  nav a {
    text-decoration: none;
  }

  .static-template__toolbar {
    text-align: center;
    padding: 15px 0 0;
    background-color: #f1f5f9;
    display: flex;
    justify-content: center;
    gap: 5px;
    flex-direction: column;
    @media (min-width: 800px) {
      flex-direction: row;
      align-items: center;
      gap: 20px;
    }
  }

  header .v-toolbar__content {
    display: flex;
    flex-direction: column;
    padding: 0;
    background-color: transparent;
  }
  header a.router-link-exact-active {
    color: #1e1e1e !important;
    cursor: default !important;
    height: 48px;
    align-items: center;
    position: relative;
    &:after {
      content: '_';
      position: absolute;
      bottom: 0;
      border-bottom: 2px solid grey;
      color: transparent;
      width: calc(100% + 4px);
    }
  }

  .container {
    padding-top: 40px;
  }
  .app-navigation-menu {
    display:flex;
    gap: 10px;
    align-items: center;
    flex: 1;
    @media (min-width: 800px) {
      gap: 40px;
    }
  }
</style>

<template>
  <v-app style="background-color: #f1f5f9;">
    <div v-if="isViewMode" class="static-template__toolbar">
      <a href="/builder/#/templates">
        <v-btn text color="primary" style="background-color: #1976d20f;">
          <v-icon medium color="primary" style="margin-right: 10px; font-size: 14px;">mdi-arrow-left</v-icon>
          <span style="text-decoration: underline;">{{ translate('ui_view_more_templates') }}</span>
        </v-btn>
      </a>
      <span>or</span>
      <a href="/builder/#/template/new">
        <v-btn text color="primary" style="background-color: #1976d20f;">
          <span style="text-decoration: underline;">{{ translate('ui_view_ai_build_new_template') }}</span>
          <v-icon medium color="primary" style="margin-left: 10px; font-size: 14px;">mdi-arrow-right</v-icon>
        </v-btn>
      </a>
    </div>

    <div v-if="$store.state.ready.languagesLoaded">
      <v-navigation-drawer
        v-if="!this.isViewMode"
        v-model="drawer"
        absolute
        temporary
        :touchless=true
      >
        <v-list dense style="padding-top: 0;">
          <v-list-item>
            <v-list-item-action>
              <v-icon @click.stop="drawer = false">mdi-menu</v-icon>
            </v-list-item-action>
          </v-list-item>

          <v-divider></v-divider>

          <router-link :to="getHref(menuItems.templates)" style="text-decoration: none; font-family: Inter;">
            <v-list-item>
              <v-list-item-action>
                <v-icon :color="menuItems.templates.iconColor">{{menuItems.templates.icon}}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ menuItems.templates.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link v-if="$store.state.activeTemplate" :to="getHref('template')" style="text-decoration: none; font-family: Inter;">
            <v-list-item>
              <v-list-item-action>
                <v-icon :color="menuItems.template.iconColor" style="font-size: 16px; margin-right: 5px;">{{menuItems.template.icon}}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  <span style="max-width: 100px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    {{ $store.state.activeTemplate.name }}
                  </span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link :to="getHref(menuItems.settings)" style="text-decoration: none; font-family: Inter;">
            <v-list-item>
              <v-list-item-action>
                <v-icon :color="menuItems.settings.iconColor">{{menuItems.settings.icon}}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ menuItems.settings.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link :to="getHref(menuItems.feedback)" style="text-decoration: none; font-family: Inter;">
            <v-list-item>
              <v-list-item-action>
                <v-icon :color="menuItems.feedback.iconColor">{{menuItems.feedback.icon}}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ menuItems.feedback.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

        </v-list>
      </v-navigation-drawer>

      <v-app-bar
        app
        v-if="shouldShowAppBar"
        elevate-on-scroll
        elevation="1"
        dense
        style="background: #d5e1ed;"
      >
        <div style="color: #000; width: 100%;">
          <div style="height: 48px; width: 100%; max-width: 1200px; display: flex; align-items: center; gap: 20px; font-size: 12px; margin: 0 auto; padding: 0 10px;  font-family: Inter;">
            <v-btn text class="d-md-none" style="padding: 0" min-width="0">
              <v-icon @click.stop="drawer = !drawer">mdi-menu</v-icon>
            </v-btn>
            <div style="display:flex; gap: 30px; align-items: center; flex: 1;">
              <a :href="getHref(menuItems.home)" style="text-decoration: none; display: flex; color: #000">
                <svg
                  style="height: 14px; margin-right: 5px; margin-top: 2px;"
                  viewBox="0 0 16 16"
                  xmlns="http://www.w3.org/2000/svg">
                  <path d="m8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm-4 8c0-2.2 1.8-4 4-4s4 1.8 4 4-1.8 4-4 4-4-1.8-4-4zm8.6 1.8c.3-.5.4-1.2.4-1.8s-.1-1.3-.4-1.8l1.5-1.5c.6 1 .9 2.1.9 3.3s-.3 2.3-.8 3.3zm-1.3-8-1.5 1.6c-.5-.3-1.2-.4-1.8-.4s-1.3.1-1.8.4l-1.5-1.6c1-.5 2.1-.8 3.3-.8s2.3.3 3.3.8zm-9.5 2.9 1.5 1.5c-.2.5-.3 1.2-.3 1.8s.1 1.3.4 1.8l-1.5 1.5c-.6-1-.9-2.1-.9-3.3s.3-2.3.8-3.3zm2.9 9.5 1.5-1.5c.5.2 1.2.3 1.8.3s1.3-.1 1.8-.4l1.5 1.5c-1 .6-2.1.9-3.3.9s-2.3-.3-3.3-.8z"
                        fill="#000"/>
                </svg>
                {{ menuItems.home.title }}
              </a>

              <router-link class="d-none d-md-flex" :to="getHref(menuItems.templates)" style="text-decoration: none; font-family: Inter;">
                <v-icon :color="menuItems.templates.iconColor" style="font-size: 16px; margin-right: 5px;">{{menuItems.templates.icon}}</v-icon>
                {{ menuItems.templates.title }}
              </router-link>

              <v-spacer/>

              <div v-if="$store.state.activeTemplate && $store.state.activeTemplate.uuid" style="flex: 1; display: flex; align-items: center; gap: 50px; justify-content: space-between">
                <router-link
                  class="d-none d-md-flex"
                  :to="getHref('template')"
                  style="text-decoration: none; font-family: Inter;"
                >
                  <v-icon :color="menuItems.template.iconColor" style="font-size: 16px; margin-right: 5px;">{{menuItems.template.icon}}</v-icon>
                  <span style="max-width: 150px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                      {{ $store.state.activeTemplate.name }}
                    </span>
                </router-link>
                <TemplateToolbar style="flex: 1"/>
              </div>

              <v-spacer/>

              <SupportBtn/>

              <router-link class="d-none d-md-flex" :to="getHref(menuItems.feedback)" style="text-decoration: none; font-family: Inter;">
                <v-icon :color="menuItems.feedback.iconColor" style="font-size: 16px; margin-right: 5px;">{{menuItems.feedback.icon}}</v-icon>
                <span :style="`color: ${menuItems.feedback.iconColor}`">{{ menuItems.feedback.title }}</span>
              </router-link>

              <router-link to="/settings" v-if="this.$store.state.loggedin" style="display: flex; text-decoration: none;">
                <v-avatar
                  color="primary"
                  size="30"
                >
                  <span v-if="initials.length" style="color: #fff;">{{ initials }}</span>
                  <v-icon v-if="!initials.length" style="color: #fff; font-size: 20px;">mdi-account</v-icon>
                </v-avatar>
              </router-link>

              <router-link to="/" v-if="!this.$store.state.loggedin" style="display: flex; text-decoration: none; font-family: Inter;">
                <v-icon :color="menuItems.login.iconColor" style="font-size: 16px; margin-right: 5px; top: -1px;">{{menuItems.login.icon}}</v-icon>
                {{ menuItems.login.title }}
              </router-link>
            </div>
          </div>
        </div>

        <div v-if="false && isTemplateRoute" style="width: 100%; height: 70px; padding: 10px; background: #f1f5f9;">
          <div style="display: flex; max-width: 1200px; margin: 0 auto;">
            <v-toolbar-title style="max-width: 600px;">
              <span v-html="currentPageTitle"></span>
            </v-toolbar-title>
            <v-spacer></v-spacer>

            <div style="display: flex;">
              <TemplateToolbar/>
            </div>
          </div>
        </div>
      </v-app-bar>

      <v-main style="transition: none; background-color: #f1f5f9;">
        <router-view></router-view>
      </v-main>
    </div>

    <div v-if="!$store.getters.ready"
      justify="center"
      alignContent="center"
    >
      <v-progress-circular
        color="red"
        :size="50"
        :width="3"
        indeterminate
        style="position: fixed; top: 50%; left: 50%"
      ></v-progress-circular>
    </div>

    <v-footer padless absolute>
      <v-card
        class="flex"
        flat
        tile
        color="#757e88"
      >
        <v-card-text class="white--text text-center" style="display: flex; justify-content: center; align-items: center; gap: 5px; padding: 2px;">
          <svg style="height: 14px;" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="m8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm-4 8c0-2.2 1.8-4 4-4s4 1.8 4 4-1.8 4-4 4-4-1.8-4-4zm8.6 1.8c.3-.5.4-1.2.4-1.8s-.1-1.3-.4-1.8l1.5-1.5c.6 1 .9 2.1.9 3.3s-.3 2.3-.8 3.3zm-1.3-8-1.5 1.6c-.5-.3-1.2-.4-1.8-.4s-1.3.1-1.8.4l-1.5-1.6c1-.5 2.1-.8 3.3-.8s2.3.3 3.3.8zm-9.5 2.9 1.5 1.5c-.2.5-.3 1.2-.3 1.8s.1 1.3.4 1.8l-1.5 1.5c-.6-1-.9-2.1-.9-3.3s.3-2.3.8-3.3zm2.9 9.5 1.5-1.5c.5.2 1.2.3 1.8.3s1.3-.1 1.8-.4l1.5 1.5c-1 .6-2.1.9-3.3.9s-2.3-.3-3.3-.8z"
                                                                            fill="#fff"/></svg>
          <span style="font-family: Inter; font-size: 14px; font-weight: 700;"><a href="https://www.finmodelbuilder.com" style="text-decoration: none; color: #fff;">finmodelbuilder.com</a></span>
        </v-card-text>
      </v-card>
    </v-footer>

    <v-dialog
      v-model="this.$store.state.dialogs.shouldShowSystemDownDialog"
      max-width="500"
      persistent
      style="overflow: hidden;"
    >
      <div style="background: #fff; padding: 30px; text-align: center; font-size: 18px;">
        <v-icon style="color: red; font-size: 40px; margin-bottom: 20px;">mdi-alert</v-icon>
        <div v-html="systemDownMessage"></div>
      </div>
    </v-dialog>
  </v-app>


</template>

<script>

// mixins
import TemplateToolbar from '@/pages/Template/TemplateToolbar.vue';
import SupportBtn from '@/SupportBtn.vue';
import Mixin from './mixins/mixin';
import store from './store';

export default {
  name: 'App',
  data: () => ({
    drawer: null,
    mini: true,
    building: false,
    loader: null,
  }),
  components: {
    SupportBtn,
    TemplateToolbar,
  },
  mixins: [Mixin],
  methods: {
    getHref(menuItem) {
      let result = menuItem.href;
      if (menuItem === 'template') {
        result = `/template/${this.$store.state.activeTemplate.uuid}`;
      }
      return result;
    },
  },
  created: async () => {
    if (window.template) {
      await store.dispatch('getDefaultTemplateData');
      store.dispatch('updateState', {
        path: 'mode',
        value: 'static',
      });
      store.dispatch('updateState', {
        path: 'languages',
        value: window.template.languages,
      });
      // set ready flags
      store.dispatch('updateState', {
        path: 'ready.userLoaded',
        value: true,
      });
      store.dispatch('updateState', {
        path: 'ready.languagesLoaded',
        value: true,
      });
      store.dispatch('updateState', {
        path: 'ready.defaultDataLoaded',
        value: true,
      });
      store.dispatch('updateState', {
        path: 'ready.templateGalleryLoaded',
        value: true,
      });
      // store.dispatch('getModulesData');
      store.dispatch('getUserData');
    } else {
      await store.dispatch('getUserData');
      store.dispatch('getDefaultTemplateData');
      store.dispatch('getLanguageData');
      store.dispatch('getTemplateGallery');
    }
  },
  computed: {
    navigationDrawerMenuItems() {
      return this.menuItems.filter((item) => item.key !== 'home' && item.key !== 'settings');
    },
    systemDownMessage() {
      let result = '<p>Sorry for the interruption,<br>but system is down right now.</p><p>We should be back on soon.</p>';
      if (this.$store.state.languages) {
        result = this.translate('ui_system_down');
      }
      return result;
    },
    isViewMode() {
      return this.$store.state.mode === 'static';
    },
    shouldShowAppBar() {
      return !this.isViewMode;
      // this.isTemplateRoute && this.$store.state.activeTemplate && this.$store.state.activeTemplate.isGenerating === 'done' && !this.isViewMode;
      // return false;
      // return this.$store.state.loading === false && !this.isTemplateRoute && !this.isViewMode;
    },
    isTemplateRoute() {
      return this.$route.path.search(/template\//) !== -1;
    },
    initials() {
      const lastName = this.$store.state.user.lastName ? this.$store.state.user.lastName[0] : '';
      const firstName = this.$store.state.user.firstName ? this.$store.state.user.firstName[0] : '';
      return `${firstName}${lastName}`.toUpperCase();
    },
    showMenuItem(item) {
      return !item.settings && !item.login;
    },
    currentPageTitle() {
      const currentPageTitle = this.isTemplateRoute && this.$store.state.activeTemplate ? this.$store.state.activeTemplate.name : '';
      return currentPageTitle;
    },
    menuItems() {
      // eslint-disable-next-line
      const { menuItems } = this.$store.state;
      // const filteredMenuItems = menuItems.reduce((arr, item) => {
      //   if ((this.$store.state.loggedin && item.key !== 'login' && item.key !== 'settings') || !this.$store.state.loggedin) {
      //     arr.push(item);
      //   }
      //   return arr;
      // }, []);
      // eslint-disable-next-line

      const { language } = this.$store.state.user.settings;
      if (this.$store.state.languages) {
        Object.keys(menuItems).forEach((key) => {
          menuItems[key].title = this.translate(menuItems[key].title, language);
        });
        // result = filteredMenuItems.map((menuItem) => {
        //   // eslint-disable-next-line
        //   menuItem.title = this.translate(menuItem.title, language);
        //   return menuItem;
        // });
      }

      return menuItems;
    },
  },
  mounted() {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    const vh = window.innerHeight / 100;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    // We listen to the resize event
    window.addEventListener('resize', () => {
      // We execute the same script as before
      const vh1 = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh1}px`);
    });

    // check if mobile
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    this.$store.dispatch('updateState', {
      path: 'isMobile',
      value: isMobile,
    });

    // start healthcheck
    this.$store.dispatch('startHealthCheck');

    const confettiScript = document.createElement('script');
    confettiScript.setAttribute(
      'src',
      'https://cdn.jsdelivr.net/npm/canvas-confetti@1.5.1/dist/confetti.browser.min.js',
    );
    document.head.appendChild(confettiScript);
  },
};
</script>
